import type from './type'
import location from './location'
import connection from './connection'

const node = {
  getById: {
    method: 'get',
    url: '/admincp/node/ID'
  },
  getList: {
    method: 'post',
    url: '/admincp/node/list?archive=ARCHIVE'
  },
  getAll: {
    method: 'post',
    url: '/admincp/node/get-all'
  },
  addNode: {
    method: 'post',
    url: '/admincp/node'
  },
  update: {
    method: 'put',
    url: '/admincp/node'
  },
  updateRelationNode: {
    method: 'post',
    url: '/admincp/node/update-relation-node'
  },
  delete: {
    method: 'delete',
    url: '/admincp/node'
  },
  archive: {
    method: 'delete',
    url: '/admincp/node/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/node/restore'
  },
  findNodes: {
    method: 'get',
    url: '/admincp/node/find?key=KEY&type=NODETYPE'
  },
  findNodeByType: {
    method: 'post',
    url: '/admincp/node/find/by-type-id'
  },
  findNodeConnections: {
    method: 'post',
    url: '/admincp/node/findNodeConnection?key=KEY&limit=LIMIT'
  },
  getHistory: {
    method: 'post',
    url: '/admincp/node/history/list'
  },
  getNodeTypes: {
    method: 'get',
    url: '/admincp/node/types'
  },
  getTransportTypes: {
    method: 'get',
    url: '/admincp/node/transport-types'
  },
  getNodeAndWareHouseTypes: {
    method: 'get',
    url: '/admincp/node/node-and-warehouse-types'
  }
}

export default {
  ...node,
  type,
  location,
  connection
}
